import React, { Component } from "react";

import _ from "lodash";

import "./skeleton.css";
export default class SkeletonText extends Component {
  render() {
    const lines = this.props.lines || 5;
    return (
      <React.Fragment>
        {_.times(lines, i => <span key={i} className="loading__text" />).map(
          item => item
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/skeleton/SkeletonText.js